import {
  CampaignContributionTableHeader,
  CampaignContributionTableHeaderAndSortMap,
  CampaignContributionTableSort,
} from '../types';

export const MAP_CAMPAIGN_CONTRIBUTIONS_TABLE_HEADER_AND_SORT_ID: CampaignContributionTableHeaderAndSortMap =
  {
    [CampaignContributionTableSort.CAMPAIGN]: CampaignContributionTableHeader.CAMPAIGN,
    [CampaignContributionTableSort.MESSAGE_MEDIUM]: CampaignContributionTableHeader.MESSAGE_MEDIUM,
    [CampaignContributionTableSort.START_AT]: CampaignContributionTableHeader.START_AT,
    [CampaignContributionTableSort.STATUS]: CampaignContributionTableHeader.STATUS,
    [CampaignContributionTableHeader.CAMPAIGN]: CampaignContributionTableSort.CAMPAIGN,
    [CampaignContributionTableHeader.MESSAGE_MEDIUM]: CampaignContributionTableSort.MESSAGE_MEDIUM,
    [CampaignContributionTableHeader.START_AT]: CampaignContributionTableSort.START_AT,
    [CampaignContributionTableHeader.STATUS]: CampaignContributionTableSort.STATUS,
  };
